/** Paginação por cursor (contrato FASE-02-T04 / PageInfoDto). */
export type CursorPageInfo = {
  nextCursor: string | null;
  hasMore: boolean;
};

export type CursorPage<T> = {
  data: T[];
  pageInfo: CursorPageInfo;
};

/** Próximo `pageParam` para `useInfiniteQuery`, ou `undefined` se acabou. */
export function getNextCursor(pageInfo: CursorPageInfo): string | undefined {
  if (!pageInfo.hasMore || pageInfo.nextCursor == null || pageInfo.nextCursor === "") {
    return undefined;
  }
  return pageInfo.nextCursor;
}

/** Achata páginas de cursor numa lista única. */
export function flattenCursorPages<T>(pages: readonly CursorPage<T>[]): T[] {
  return pages.flatMap((page) => page.data);
}
